export default __webpack_public_path__ + "static/media/mobileBottom.d0766ee1.png";